interface FormCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
}

const FormCheckbox = ({ label, checked, onChange }: FormCheckboxProps) => (
  <div
    className={`flex items-center gap-3 px-4 py-3.5 rounded-lg border cursor-pointer transition-all select-none ${
      checked ? "border-[#CBA135] bg-[#FFF8E7]" : "border-[#E0E0E0] bg-white hover:bg-gray-50"
    }`}
    onClick={() => onChange(!checked)}
  >
    <div
      className={`w-5 h-5 rounded flex items-center justify-center shrink-0 border transition-all ${
        checked ? "bg-[#CBA135] border-[#CBA135]" : "border-[#BDBDBD] bg-white"
      }`}
    >
      {checked && (
        <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
          <path
            d="M1 4L3.5 6.5L9 1"
            stroke="white"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
    <span className="text-sm text-dark-100">{label}</span>
  </div>
);

export default FormCheckbox;
